<template>
  <div class="container">
    <canvas ref="elemento" :id="IdGrafico"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(ChartDataLabels);

export default {
  props: ["Labels", "DatosGrafico", "Title", "Labelsdataset", "Labelscale_x", "Labelscale_y", "IdGrafico", "Tamanio", "Orientacion", "TooltipLines", "SelectedIndex"],
  data() {
    return {
      tamanioletra: 11,
      orientacioneje: "",
      chartInstance: null
    };
  },
  watch: {
    SelectedIndex() {
      if (this.chartInstance && this.Labels) {
        this.chartInstance.data.datasets[0].backgroundColor = this.obtenerColoresBarra();
        this.chartInstance.data.datasets[0].borderColor = this.obtenerBordesBarra();
        this.chartInstance.data.datasets[0].borderWidth = this.obtenerAnchoBorde();
        this.chartInstance.update();
      }
    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
  methods: {
    obtenerColoresBarra() {
      if (!this.Labels) return "rgb(27, 205, 249)";
      if (this.SelectedIndex === null || this.SelectedIndex === undefined) {
        return this.Labels.map(() => "rgb(27, 205, 249)");
      }
      return this.Labels.map((_, i) => {
        if (i === this.SelectedIndex) {
          return "#0288D1";
        }
        return "rgba(27, 205, 249, 0.35)";
      });
    },

    obtenerBordesBarra() {
      if (!this.Labels) return "transparent";
      if (this.SelectedIndex === null || this.SelectedIndex === undefined) {
        return this.Labels.map(() => "transparent");
      }
      return this.Labels.map((_, i) => {
        if (i === this.SelectedIndex) {
          return "#01579B";
        }
        return "transparent";
      });
    },

    obtenerAnchoBorde() {
      if (!this.Labels) return 0;
      if (this.SelectedIndex === null || this.SelectedIndex === undefined) {
        return this.Labels.map(() => 0);
      }
      return this.Labels.map((_, i) => (i === this.SelectedIndex ? 2 : 0));
    },

    generarGrafico: function () {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      var popCanvas = document.getElementById(this.IdGrafico);
      if (!popCanvas) return;

      this.chartInstance = new Chart(popCanvas, {
        plugins: [ChartDataLabels],
        type: "bar",
        data: {
          labels: this.Labels,
          datasets: [
            {
              label: this.Labelsdataset,
              data: this.DatosGrafico,
              backgroundColor: this.obtenerColoresBarra(),
              borderColor: this.obtenerBordesBarra(),
              borderWidth: this.obtenerAnchoBorde(),
              hoverOffset: 4,
            },
          ],
        },
        options: {
          onClick: (event, activeElements) => {
            if (activeElements && activeElements.length > 0) {
              const index = activeElements[0].index;
              this.$emit("click-bar", index);
            }
          },
          onHover: (event, chartElement) => {
            if (event && event.native && event.native.target) {
              event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
            }
          },
          indexAxis: this.orientacioneje,
          plugins: {
            title: {
              display: true,
              text: this.Title,
            },
            legend: {
              display: false,
              position: "right",
              labels: {
                color: "black",
                font: {
                  size: 11,
                },
              },
            },
            datalabels: {
              display: true,
              /* anchor puede ser "start", "center" o "end" */
              anchor: "end",
              align: "end",
              /* Podemos modificar el texto a mostrar */
              //formatter: (dato) => dato + "%",
              formatter: (dato) => dato,
              /* Color del texto */
              color: "black",
              /* Formato de la fuente */
              font: {
                family: '"Times New Roman", Times, serif',
                size: this.tamanioletra,
                weight: "bold",
              },
              /* Formato de la caja contenedora */
              //padding: "4",
              //borderWidth: 2,
              //borderColor: "darkblue",
              //borderRadius: 8,
              //backgroundColor: "white"
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  const val = context.raw;
                  if (val !== undefined) {
                    const extraLines = this.TooltipLines ? this.TooltipLines[context.dataIndex] : null;
                    if (extraLines && Array.isArray(extraLines)) {
                      return [label + val].concat(extraLines);
                    }
                    return label + val;
                  }
                  return label;
                }
              }
            },
          },
          tooltips: {
            yAlign: "bottom",
            xAlign: "center",
            xPadding: 25,
            yPadding: 15,
            xPadding: 45,
            _bodyAlign: "center",
            _footerAlign: "center",
            backgroundColor: "#ccc",
            titleFontSize: 16,
            titleFontColor: "#0066ff",
            bodyFontColor: "#000",
            bodyFontSize: 14,
            displayColors: false,
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: this.Labelscale_x,
              },
              beginAtZero: true, // Asegura que el eje X (eje horizontal en un gráfico de barras horizontales) comience desde 0
              suggestedMin: 0, // Asegura que el gráfico comience desde 0 en el eje X
              grace: '5%',
            },
            y: {
              display: true,
              title: {
                display: true,
                text: this.Labelscale_y,
              },
              ticks: this.orientacioneje === 'y' ? {
                autoSkip: false
              } : {},
              suggestedMin: 0,
              grace: '5%',
            },
          },
        },
      });
    },
  },
  mounted() {
    if (this.Tamanio != undefined && this.Tamanio != null) {
      this.tamanioletra = 9
    }
    if (this.Orientacion != undefined && this.Orientacion != null) {
      this.orientacioneje = this.Orientacion
    }
    this.generarGrafico();
  },
};
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  max-width: 100%;
  padding: 8px 12px;
}
canvas {
  max-width: 100%;
}
</style>